import { Auth } from "aws-amplify";
import "crypto-js/lib-typedarrays";
import configAws from "../../configAws";

Auth.configure(configAws);

export const amplify = {
  signUp: (username, password, attributes = {}) =>
    Auth.signUp(username, password, attributes),
  signIn: (username, password) => Auth.signIn(username, password),
  signOut: () => {
    sessionStorage.clear();
    localStorage.clear();
    window.location.replace('/login');
    return Auth.signOut();
  },
  currentAuthenticatedUser: () => Auth.currentAuthenticatedUser(),
  userAttributes: () => Auth.userAttributes(),
  confirmSignUp: (username, code) => Auth.confirmSignUp(username, code),
  forgotPassword: (username) => Auth.forgotPassword(username),
  resendSingUp: (username) => Auth.resendSignUp(username),
  changePassword: (user, oldPassword, newPassword) =>
    Auth.changePassword(user, oldPassword, newPassword),
  forgotPasswordSubmit: (user, code, password) =>
    Auth.forgotPasswordSubmit(user, code, password),
};

export const isAuthenticated = () => {
  return Auth.currentSession()
  /*const endSession = JSON.parse(localStorage.getItem("expires"));
  const startSession = new Date().getTime();
  if (startSession < endSession) {
    return true;
  }
  localStorage.setItem("active", 0);
  return false;*/
};
